{
	"backToStartPage": "Tilbake til startsiden",
	"transactionDetailsTitle": "Transaksjonsdetaljer",
	"btnVerifyTransactions": "Bekreft transaksjoner",
	"kpi": {
		"date": "Dato",
		"quantity": "Mengde",
		"carbonReductions": "Karbonreduksjoner"
	},
	"verifyTransactionModal": {
		"title": "Bekreft transaksjonen",
		"description": "Vennligst skriv inn post-ID for denne transaksjonen. Du finner informasjonen på erklæringen.",
		"recordIdLabel": "Post-ID",
		"cancelTitle": "Avbryt",
		"verifyTitle": "Bekreft",
		"errors": {
			"recordIdRequired": "Post-ID kreves",
			"recordIdInvalid": "Post-ID må være på 16 tegn (bokstaver eller tall), formatert som ABCD 1234 EFGH 5678",
			"verificationFailed": "Transaksjonen kunne ikke bekreftes. Vennligst sjekk post-ID"
		}
	},
	"errors": {
		"notFound": "Transaksjonen ble ikke funnet"
	}
}
